import Button from '@atlaskit/button/standard-button';
import ModalDialog, {
  ModalTransition,
  ModalBody,
  ModalTitle,
  ModalHeader,
  ModalFooter,
} from '@atlaskit/modal-dialog';

import React from 'react';
import { FormattedMessage } from 'react-intl';

import config from 'appconfig';
import t from 'modules/i18n/intl';

const contactUsLink = (chunks) => (
  <a href={config.companyContact} target="_blank" rel="noreferrer">
    {chunks}
  </a>
);

const ViewDownloadSourceModalDialog = ({ isModalOpened, onClose }) =>
  isModalOpened && (
    <ModalTransition>
      <ModalDialog autoFocus shouldCloseOnEscapePress width="medium">
        <ModalHeader>
          <ModalTitle>
            <FormattedMessage id="mac.licenses.download.source" defaultMessage="Download Source" />
          </ModalTitle>
        </ModalHeader>

        <ModalBody>
          {t(
            {
              id: 'mac.licenses.download-source.modal.message',
              defaultMessage:
                'There are currently no source downloads available for your license. Please <contactUsLink>contact us</contactUsLink> for further details.',
            },
            {
              contactUsLink,
            },
          )}
        </ModalBody>
        <ModalFooter>
          <Button onClick={onClose} appearance="subtle">
            <FormattedMessage
              id="mac.licenses.download-source.modal.button"
              defaultMessage="Close"
            />
          </Button>
        </ModalFooter>
      </ModalDialog>
    </ModalTransition>
  );

export default ViewDownloadSourceModalDialog;
